export const environment = {
    name: 'qual',

    production: true,

    apiUrl: 'https://qual-ffv2020.bizzdev.net/api',

    apiDomain: 'qual-ffv2020.bizzdev.net',
    identityApiUrl: 'https://qual-ffv2020.bizzdev.net/identity/',
    whiteListedUrl: 'https://qual-ffv2020.bizzdev.net/api',
    socialBlackListedUrl: 'https://qual-ffv2020.bizzdev.net/api/user/socials/login',
    blacklistedUrl: 'https://qual-ffv2020.bizzdev.net/identity/',
    returnUrl: 'https://qual-ffv2020.bizzdev.net',

    tokenKey: 'bizz-ffv-token',
    tokenExpKey: 'bizz-ffv-token-exp',
    rfTokenKey: 'bizz-ffv-rf-token',

    idFacebook: '1981726191961067',

    urlRssCoaching: 'https%3A%2F%2Fwww.youtube.com%2Ffeeds%2Fvideos.xml%3Fchannel_id%3DUCmZtavTy_6Owy2A2ZqClMQA&api_key=hbjwusadcpcxqbjkmllfgeqtv0x8jmhdy7zzwrjn&order_by=pubDate&count=50',


    idGoogle: '82194560435-n8uosgouou49643aoomq4egl9ntp12p5.apps.googleusercontent.com',
    // idGoogleSocial: '82194560435-3db9didmltg0rfe3m40k6oehc6g0nr7d.apps.googleusercontent.com',


};
